import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { EscuelaService } from './escuela.service';
import { EmailPayload, EmailFacturaPayload } from '../models/email.model';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends BaseService<any> {
  constructor(
    protected http: HttpClient,
    protected escuelaService: EscuelaService
  ) {
    super(http);
    this.options = { route: 'email' };
  }

  enviarEmail(data: any): Observable<any> {
    // if (this.escuelaService && this.escuelaService.Escuela()) {
    //   data.colegio = data.colegio || this.escuelaService.Escuela().nombre;
    //   data.direccion = data.direccion || this.escuelaService.Escuela().direccion;
    //   data.telefono =
    //     data.telefono ||
    //     `${this.escuelaService.Escuela().telefono1 || ''} - ${
    //       this.escuelaService.Escuela().telefono2 || ''
    //     }`;
    // }

    return this.http.post<any>(`${this.url}/enviar`, data, {
      headers: new HttpHeaders().set('x-token', this.token),
    });
  }

  enviarEmailFactura(data: EmailFacturaPayload): Observable<any> {
    if (this.escuelaService && this.escuelaService.Escuela()) {
      data.colegio = data.colegio || this.escuelaService.Escuela().nombre;
      data.direccion = data.direccion || this.escuelaService.Escuela().direccion;
      data.telefono =
        data.telefono ||
        `${this.escuelaService.Escuela().telefono1 || ''} - ${
          this.escuelaService.Escuela().telefono2 || ''
        }`;
    }

    return this.http.post<any>(`${this.url}/enviarEmailFactura`, data, {
      headers: new HttpHeaders().set('x-token', this.token),
    });
  }
}
